import { SingleSelect, SingleSelectProps } from '../single-select';

import { SortParams } from '../../constants/types';
import { conditionalSpread } from '../../utils/helper-utils';

export const RELEVANCE_SORT: SortParams = { key: 'relevance', direction: 'desc' };

export const SortMenu = (props: SortMenuProps) => {
  const { sort, onSort, showNumTagsSort, showRelevanceSort, disabled, ...rest } = props;

  const isSelected = (key: string, dir: string) => {
    if (!sort) {
      return false;
    }

    return sort.key === key && sort.direction === dir;
  };

  const sortOptions = [
    ...conditionalSpread(
      [
        {
          icon: 'search-01',
          name: 'Relevance',
          displayName: 'Relevance',
          selected: isSelected(RELEVANCE_SORT.key, RELEVANCE_SORT.direction),
          onClick: () => onSort(RELEVANCE_SORT),
        },
        {
          type: 'divider',
        },
      ],
      !!showRelevanceSort
    ),
    {
      type: 'group',
      name: 'Name by',
    },
    {
      name: 'A - Z',
      displayName: 'Name A - Z',
      icon: 'arrange-by-letters-a-z',
      selected: isSelected('name', 'asc'),
      onClick: () => onSort({ key: 'name', direction: 'asc' }),
    },
    {
      name: 'Z - A',
      displayName: 'Name Z - A',
      icon: 'sorting-z-a-01',
      selected: isSelected('name', 'desc'),
      onClick: () => onSort({ key: 'name', direction: 'desc' }),
    },
    {
      type: 'divider',
    },
    {
      type: 'group',
      name: 'Updated by',
    },
    {
      icon: 'sorting-9-1',
      name: 'Latest Update',
      displayName: 'Updated Latest',
      selected: isSelected('updatedAt', 'desc'),
      onClick: () => onSort({ key: 'updatedAt', direction: 'desc' }),
    },
    {
      icon: 'arrange-by-numbers-9-1',
      name: 'Earliest',
      displayName: 'Updated Earliest',
      selected: isSelected('updatedAt', 'asc'),
      onClick: () => onSort({ key: 'updatedAt', direction: 'asc' }),
    },
    {
      type: 'divider',
    },
    {
      type: 'group',
      name: 'Created by',
    },
    {
      icon: 'sort-by-down-01',
      name: 'Latest',
      displayName: 'Created Latest',
      selected: isSelected('createdAt', 'desc'),
      onClick: () => onSort({ key: 'createdAt', direction: 'desc' }),
    },
    {
      icon: 'sort-by-up-01',
      name: 'Earliest',
      displayName: 'Created Earliest',
      selected: isSelected('createdAt', 'asc'),
      onClick: () => onSort({ key: 'createdAt', direction: 'asc' }),
    },
    ...conditionalSpread(
      [
        {
          type: 'divider',
        },
        {
          type: 'group',
          name: 'Items Count',
        },
        {
          icon: 'sorting-9-1',
          name: 'Ascending',
          displayName: 'Ascending',
          selected: isSelected('numTags', 'asc'),
          onClick: () => onSort({ key: 'numTags', direction: 'asc' }),
        },
        {
          icon: 'arrange-by-numbers-9-1',
          name: 'Descending',
          displayName: 'Descending',
          selected: isSelected('numTags', 'desc'),
          onClick: () => onSort({ key: 'numTags', direction: 'desc' }),
        },
      ],
      !!showNumTagsSort
    ),
  ];

  return <SingleSelect appearance="greyscale" options={sortOptions} maxWidth={150} disabled={disabled} {...rest} />;
};

export interface SortMenuProps extends Omit<SingleSelectProps, 'options'> {
  sort: SortParams | null;
  disabled?: boolean;
  showNumTagsSort?: boolean;
  showRelevanceSort?: boolean;
  onSort: (sort: SortParams) => void;
}
